/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Size of an avalanche
 * @export
 * @enum {string}
 */

export const AvalancheSize = {
    One: 'ONE',
    Two: 'TWO',
    Three: 'THREE',
    Four: 'FOUR',
    Five: 'FIVE',
    Unknown: 'UNKNOWN'
} as const;

export type AvalancheSize = typeof AvalancheSize[keyof typeof AvalancheSize];



